export const tag = 'm050c050footerDealerSearch';
export const load = async () => {
    const { M050C090FooterDealerSearchComponent } = await import('./m050-c090-footer-dealer-search.component');
    return {
        component: M050C090FooterDealerSearchComponent,
    };
};
